import React, { useState, useEffect  } from 'react';
import "../App.css";
import image from '../img/home-banner.jpg';
import MobileBanner from '../img/mobile-banner.jpeg';
import img from '../img/dept img.png';
import card1 from '../img/svg icons-01.svg';
import card2 from '../img/svg icons-02.svg';
import card3 from '../img/svg icons-03.svg';
import card4 from '../img/svg icons-04.svg';
import healthcard1 from '../img/radiology.png'; 
import healthcard2 from '../img/pastoral.png'; 
import healthcard3 from '../img/blood.png'; 
import healthcard4 from '../img/clinical.png'; 
import healthcard5 from '../img/mortuary.png'; 
import healthcard6 from '../img/insurance.png'; 
import homecare from '../img/Homecare.png';
import homecaremobile from '../img/Homecaremobile.jpg';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap is imported
import { FaSearch } from 'react-icons/fa';
import { FaChevronRight } from "react-icons/fa6";
import Navbar from '../components/Navbar.js';
import OurHospitals from '../components/OurHospitals';
import Footer from '../components/Footer';
import Testimonials from '../components/Testimonials';
import PostSection from '../components/PostSection';
import ImageSlider from '../components/ImageSlider.js';
import Popup from '../components/popUp/popUp.js';

function HomePage() {

    return (
        <div>
            
            {/* Navbar */}

                <Navbar />

            {/* Navbar Ending */}

            {/* <Popup /> */}

            <div className="App-body">
                <img className="main-banner" src={image} alt="banner" />
                <img className="mobile-main-banner" src={MobileBanner} alt="mobile-banner" />
                {/* <div className="banner-box">
                    <p className="banner-box-heading">At the forefront of<br /> Gynecological Care.</p>
                    <br/>
                    <p className="banner-box-content">Committed to Excellence in Women's <br /> Health Services, Offering Comprehensive <br /> Gynecological Care for All Ages</p>
                    <br/>
                    <div className="button-find-doctor">
                        <a className="no-underline" href="/doctors"><p className="banner-box-find-doctor">Find Doctor <FaChevronRight /></p></a>
                        <button className="banner-box-appointment-button">Appointments</button>
                    </div>
                </div> */}

                {/* <ImageSlider /> */}
                
            </div>

            {/* Search Section */}

            <section className="search-section">
                <div className="container">
                    <div className="search-text">
                        <p>Find a Doctor/<br/>Search Specialities</p>
                    </div>
                    <div className="search-container">
                        <button className="search-button">
                            <a href='/doctors'>
                                <FaSearch />
                            </a>
                        </button>
                        <a href='/doctors'>
                            <input type="text" className="search-input" placeholder="Search..." />
                        </a>
                    </div>
                </div>
            </section>


            <hr className="border-line"></hr>

            {/* Card Section */}

            <section className="cards-section">
                <p className="section-header">Your Trusted Partner in Health</p>
                <br />

                <div className="d-none d-md-block">
                    <p className="card-details">Committed to excellence in care and dedicated to enhancing <br/>community well-being.</p>
                </div>

                <div className="d-md-none mb-2">
                    <p className="card-details">Committed to excellence in care and dedicated to enhancing community well-being.</p>
                </div>

                
                <div className="card-container">
                    <div className="card">
                        <div className="card-img-div">
                            <img src={card1} alt="Card 1" className="card-image"/>
                        </div>
                        <div className="card-content">
                            <p className="card-heading">Video Consultation</p><br />
                            <p className="card-paragraph">Access expert medical advice from the comfort of you home.</p>
                            <a href="/video-consultation" className="read-more"><p>Book Now <FaChevronRight /> </p></a>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-img-div">
                            <img src={card2} alt="Card 2" className="card-image health-package-2"/>
                        </div>
                        <div className="card-content">
                            <p className="card-heading">Health Checkup Packages</p><br />
                            <p className="card-paragraph">Comprehensive health assessments tailored to you needs.</p>
                            <a href="https://www.caritashospital.org/health-checkup-packages" className="read-more"><p>View Packages <FaChevronRight /> </p></a>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-img-div">
                            <img src={card3} alt="Card 3" className="card-image"/>
                        </div>
                        <div className="card-content">
                            <p className="card-heading">Directions to Reach</p><br />
                            <p className="card-paragraph">Essential information to reach Caritas Matha Hospital.</p>
                            <a href="/directions-to-reach" className="read-more"><p>Know More <FaChevronRight /> </p></a>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-img-div">
                            <img src={card4} alt="Card 4" className="card-image"/>
                        </div>
                        <div className="card-content">
                            <p className="card-heading">Careers</p><br />
                            <p className="card-paragraph">Join our team and make a difference in healthcare.</p>
                            <a href="https://www.caritashospital.org/career/" className="read-more"><p>View Openings <FaChevronRight /> </p></a>
                        </div>
                    </div>
                </div>
            </section>


            <section className="department-section">

                <p className="department-heading">Excellence in Every Speciality</p>
                <p></p>
                <div className="d-none d-md-block">
                    <p className="department-description">Providing Innovative and Compassionate Care Across All <br /> Departments to Support Health Journey at Every Stage of Life</p>
                </div>

                <div className="d-md-none mb-2">
                    <p className="department-description">Providing Innovative and Compassionate Care Across All Departments to Support Health Journey at Every Stage of Life</p>
                </div>

                <div className="department-container">
                    
                    <div className="department-links">
                        <a href="/gynaecology"><p className="dept-names"><FaChevronRight className='dept-icon'/> Obstetrics, Gynaecology and Fetal Medicine</p></a>
                        <a href="/emergency-medicine"><p className="dept-names"><FaChevronRight className='dept-icon'/> Emergency Medicine & Trauma Care</p></a>
                        <a href="/paediatrics-and-paediatrics-surgery"><p className="dept-names"><FaChevronRight className='dept-icon'/> Paediatrics & Paediatrics Surgery</p></a>
                        <a href="/neonatology"><p className="dept-names"><FaChevronRight className='dept-icon'/> Neonatology</p></a>
                        <a href="/general-medicine"><p className="dept-names"><FaChevronRight className='dept-icon'/> General Medicine</p></a>
                        <a href="/dental"><p className="dept-names"><FaChevronRight className='dept-icon'/> Dental, Oral & Maxillofacial Surgery</p></a>
                        <a href="/general-surgery"><p className="dept-names"><FaChevronRight className='dept-icon'/> General, Minimal Access and Bariatric Surgery (General Surgery)</p></a>
                        <a href="/orthopaedics"><p className="dept-names"><FaChevronRight className='dept-icon'/> Orthopaedics, Joint Replacement & Arthroscopy</p></a>
                        <a href="/ent-audiology"><p className="dept-names"><FaChevronRight className='dept-icon'/> Department of ENT & Audiology</p></a>
                        <a href="/plastic-surgery"><p className="dept-names"><FaChevronRight className='dept-icon'/> Plastic and Microvascular Surgery</p></a>
                        <a href="/dermatology"><p className="dept-names"><FaChevronRight className='dept-icon'/> Dermatology</p></a>
                        <a href="/ophthalmology"><p className="dept-names"><FaChevronRight className='dept-icon'/> Ophthalmology</p></a>
                        <a href="/cardiology"><p className="dept-names"><FaChevronRight className='dept-icon'/> Cardiology</p></a>
                        <a href="/neurology"><p className="dept-names"><FaChevronRight className='dept-icon'/> Neuro Science</p></a>
                    </div>

                    <div className="department-img">
                        <img className="dept-banner" src={img} alt="banner" />
                    </div>
                </div>

            </section>


            {/* Caritas News & Events , Articles, Testimonial*/}

                <PostSection />
            
            {/* Caritas News & Events , Articles, Testimonial Ends Here*/}

            <section>
                <div className='home-care'>
                    <img src={homecare} alt="HomeCare" className="homecare-img desktop-img" />
                    <img src={homecaremobile} alt ="Mobile Home Care" className="homecare-img mobile-img" />
                    
                    <div className="homecare-banner-box">
                        <p className="homecare-banner-box-heading">Caritas<br /> Home Care.</p>
                        <br/>
                        <p className="homecare-banner-box-content">Exceptional Home Care Services<br /> at Your Doorstep</p>
                        <br/>
                        <div className='homecare-banner-ul'>
                            <ul>
                                <li>Doctor Consultation</li>  
                                <li>Nursing Care</li>
                                <li>Laboratory Services</li>  
                                <li>Ambulance Services</li>
                            </ul>
                        </div>
                        <div className="button-find-doctor">
                            <a className="no-underline" href="/caritas-home-care"><p className="banner-box-know-more">Know More <FaChevronRight /></p></a>
                        </div>
                    </div>
                </div>
            </section>

            <section className='homecare-mobile-banner-box'>
                <div>
                    <p className="homecare-banner-box-heading">Caritas<br /> Home Care.</p>
                    <br/>
                    <p className="homecare-banner-box-content">Exceptional Home Care Services<br /> at Your Doorstep</p>
                    <br/>
                    <div className='homecare-box'>
                        <ul>
                            <li>Doctor Consultation</li>  
                            <li>Nursing Care</li>
                        </ul>
                    </div>

                    <div className='homecare-box-2'>
                        <ul>
                            <li>Laboratory Services</li>  
                            <li>Ambulance Services</li>
                        </ul>
                    </div>

                    <div className="button-find-doctor">
                        <a className="no-underline" href="/caritas-home-care"><p className="banner-box-know-more">Know More <FaChevronRight /></p></a>
                    </div>
                </div>
            </section>


            {/* Health care Services */}
            <section className="health-card-section">

                <p className="health-section-header">Our Comprehensive Healthcare Services</p>
                <br />

                <div className="d-none d-md-block">
                    <p className="health-card-details">At Caritas Matha Hospital, we offer a wide range of specialized medical services to <br/> meet the diverse needs of our patients.</p>
                </div>

                <div className="d-md-none mb-2">
                    <p className="health-card-details">At Caritas Matha Hospital, we offer a wide range of specialized medical services to meet the diverse needs of our patients.</p>
                </div>

                <div className="health-card-container">
                    <a href='/radiology-laboratory'>
                        <div className="health-card">
                            <img src={healthcard1} alt="Card 1" />
                            <div className="health-card-content">
                                <p>Radiology & Laboratory</p>
                            </div>
                        </div>
                    </a>
                    <a href='/pastoral-care'>
                        <div className="health-card">
                            <img src={healthcard2} alt="Card 2" />
                            <div className="health-card-content">
                                <p>Pastoral Care</p>
                            </div>
                        </div>
                    </a>
                    <a href='/blood-bank'>
                        <div className="health-card">
                            <img src={healthcard3} alt="Card 3" />
                            <div className="health-card-content">
                                <p>Blood Bank</p>
                            </div>
                        </div>
                    </a>
                    <a href='/clinical-nutrition'>
                        <div className="health-card">
                            <img src={healthcard4} alt="Card 4" />
                            <div className="health-card-content">
                                <p>Clinical Nutrition</p>
                            </div>
                        </div>
                    </a>
                    <a href='/caritas-mortuary-services'>
                        <div className="health-card">
                            <img src={healthcard5} alt="Card 5" />
                            <div className="health-card-content">
                                <p>Mortuary Services</p>
                            </div>
                        </div>
                    </a>
                    <a href='/insurance-partners'>
                        <div className="health-card">
                            <img src={healthcard6} alt="Card 6" />
                            <div className="health-card-content">
                                <p>Insurance Partners</p>
                            </div>
                        </div>
                    </a>
                </div>
            </section>


            {/* New Health Commitment Section */}
            <section className="health-commitment-section">
                <div className="health-commitment-container">
                    <div className="health-commitment-content">
                        <h2>Your Health, Our Commitment</h2>
                        <p>Caritas Matha Hospital, located in Kottayam, is a 250-bed facility dedicated to exceptional healthcare services, prominently focusing on Obstetrics & Gynecology. Established in 2000 as Matha Hospital and now a satellite of Caritas Hospital, it enhances medical service quality and range.</p>
                        <p>With state-of-the-art facilities and compassionate professionals, Caritas Matha Hospital embodies regional medical excellence.</p>
                        <a href="/about-caritas-matha" className="read-more-link">Read More About Us <FaChevronRight /></a>
                    </div>
                    <div className="health-commitment-counters">
                        <div className="counter">
                            <h2>10+</h2>
                            <p>Departments</p>
                        </div>

                        <div className="counter">
                            <h2>50+</h2>
                            <p>Doctors</p>
                        </div>

                        <div className="counter">
                            <h2>10+</h2>
                            <p>Medical Services</p>
                        </div>
                        
                        <div className="counter">
                            <h2>250</h2>
                            <p>Bed Facility</p>
                        </div>
                    </div>
                </div>
            </section>


            {/* Our Hospitals Section */}
            
                <OurHospitals />

                <a></a>
            
            {/* Our Hospitals Section ends */}


            <section className='testimonials-section'>
                <div className='testimonials-container'>
                    <p className='testimonials-heading'>Voices of Our Patients</p>
                    <p className='testimonials-content'>Discover the inspiring stories and testimonials from <br /> our valued patients.</p>
                </div>
                
                    <Testimonials />
                    <a href="/testimonials" className="view-all">View All <FaChevronRight /></a>
            </section>

            
            {/* Footer Starts Here */}

            <Footer />

            {/* <Departments /> */}

        </div>
    );
}

export default HomePage;
